export default function Partners() {
  const stats = [
    { number: '3.000+', label: 'Marcas Parceiras' },
    { number: '25.000+', label: 'Lojas em Todo Brasil' },
    { number: '100%', label: 'Digital e Seguro' }
  ];

  const mainPartners = [
    { name: 'Panvel', category: 'Farmácia' },
    { name: 'Droga Raia', category: 'Farmácia' },
    { name: 'Drogasil', category: 'Farmácia' },
    { name: 'Magazine Luiza', category: 'Varejo' },
    { name: 'Ponto Frio', category: 'Eletrônicos' },
    { name: 'Casas Bahia', category: 'Varejo' },
    { name: 'Fast Shop', category: 'Eletrônicos' },
    { name: 'Petz', category: 'Pet Shop' },
    { name: 'Cobasi', category: 'Pet Shop' },
    { name: 'Carrefour', category: 'Supermercado' },
    { name: 'Postos SIM', category: 'Combustível' }
  ];

  return (
    <section id="parceiros" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-[#0A1628] mb-4">Rede de Parceiros</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Mais de 3.000 marcas e 25.000 lojas parceiras em todo o Brasil. Cashback, condições especiais e benefícios reais.
          </p>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl font-bold bg-gradient-to-r from-[#00A8E8] to-[#E91E63] bg-clip-text text-transparent mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Azul Linhas Aéreas Highlight */}
        <div className="bg-gradient-to-br from-[#00A8E8]/10 to-[#E91E63]/10 rounded-3xl p-8 mb-16 border border-[#00A8E8]/20">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg">
              <i className="ri-plane-line text-4xl text-[#00A8E8]"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Azul Linhas Aéreas</h3>
              <p className="text-gray-600">
                Converta seu cashback em pontos e milhas. Viaje mais pagando menos com a integração exclusiva Azul.
              </p>
            </div>
            <div className="px-6 py-3 bg-gradient-to-r from-[#00A8E8] to-[#E91E63] text-white font-semibold rounded-full whitespace-nowrap">
              Parceiro Destaque
            </div>
          </div>
        </div>

        {/* Main Partners Grid */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">Principais Marcas Parceiras</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {mainPartners.map((partner, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-all hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-12 h-12 bg-gradient-to-br from-[#00A8E8]/20 to-[#E91E63]/20 rounded-xl flex items-center justify-center mb-3 mx-auto">
                  <i className="ri-store-2-line text-2xl text-[#00A8E8]"></i>
                </div>
                <h4 className="font-bold text-gray-800 text-center mb-1 text-sm">{partner.name}</h4>
                <p className="text-xs text-gray-500 text-center">{partner.category}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Cards */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-r from-[#00A8E8] to-[#E91E63] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">Cashback Automático</h3>
            <p className="text-gray-600 leading-relaxed">
              Receba de volta parte do valor gasto em compras nas lojas parceiras. Dinheiro direto na sua conta.
            </p>
          </div>

          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 border border-gray-100">
            <div className="w-16 h-16 bg-gradient-to-r from-[#00A8E8] to-[#E91E63] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-vip-crown-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 mb-3">Condições Especiais</h3>
            <p className="text-gray-600 leading-relaxed">
              Ofertas exclusivas e condições diferenciadas em milhares de produtos e serviços.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}